<style lang="less" scoped>
/deep/ .custom-tree-node{font-size: 14px;}
/deep/ .custom-tree-node{color: white;}
/deep/ .el-tree-node__content:hover{background: rgba(33,55,69,0);}
/deep/ .el-tree-node:focus>.el-tree-node__content{background: rgba(136, 197, 235, 0);}
/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {background: rgba(136, 197, 235, 0);}
/deep/ .tree-icon{margin-right: 5px;}
.title {text-align: center;
  span {font-size: 18px;font-weight: bold;color: white;}
}
</style>

<template>
  <cx-layout id="MapsetFileTree" gutters>
    <cx-region v-if="title" class="title" region="north" :height="titleH">
      <span :style="{'line-height': titleH + 'px'}">{{title}}</span>
    </cx-region>
    <cx-region region="center" style="overflow:auto;">
      <div style="height: 100%; width: 100%; overflow: auto;" @click="clickEmpty">
        <el-tree
          style="background: rgba(33,55,69,0);"
          ref="tree"
          :accordion="true"
          :node-key="nodeKey"
          :data="data"
          :props="props"
          highlight-current
          :default-expanded-keys="defExpands"
          @node-click="handleNodeClick"
          @node-contextmenu="nodeContext">
          <span class="custom-tree-node" slot-scope="{node, data}">
            <i v-if="!data.isFile" class="tree-icon cx-fi icon-folderopen fi-16"></i>
            <i v-else class="tree-icon cx-fi icon-ReptDetail fi-16 "></i>
            <span>{{node.label}}</span>
          </span>
        </el-tree>
        <cx-contextmenu ref="contextmenu" :func="func" :funcgrp="funcgrp"/>
      </div>
    </cx-region>
  </cx-layout>
</template>

<script>
/** 组件 - 图集 文件下载管理树 */
import ContextmenuCfg from './js/ContextmenuCfg'
import File from './js/File'
/**
 * 调用参数
 * @param  {String}            rootDir             要展示的根目录,不传时展示图集下所有的目录。
 * @param  {Boolean}           [readOnly = false]    是否只读
 * @param  {Boolean}           [showByPerm = false]  是否根据权限过滤
 * @param  {Event}             clickFile             点击树上的文件节点时的事件，传递两个参数：data(属性对象), node(节点对象)
 */
export default
{
  mixins: [ContextmenuCfg],
  props:
  {
    title: String,                                  //标题
    curPath: String,
    rootDir: {type: String, required: true},                                //要展示的根目录,必传。
    defFolders: {type: Array, default: _ => []},        //默认的子目录集合，没有会创建
    showByPerm: {type: Boolean, default: false},    //是否根据权限进行过滤展示
    readOnly: {type: Boolean, default: false},       //是否只可浏览、下载，不允许删除、新增。
    filterTreeFunc: {type: Function, default: _ => _ => true}
  },
  data()
  {
    return {
      titleH: 40,
      data: [],
      defExpands: [],
      nodeKey: 'path',
      props: {
        label: 'text',
        children: 'children'
      },
      readOnlyMenu: []              //只读状态下的右键菜单选项列表
    }
  },
  created()
  {
    this.init()
  },
  watch:
  {
    'rootDir': 'init',
    'curPath': 'setCurNode'
  },
  methods:
  {
    clickEmpty()
    {
      this.$emit('click', this.data[0])
      this.expandNode(this.data[0])
      this.$nextTick(_ => this.$refs.tree.setCurrentKey(this.data[0][this.nodeKey]))
    },
    /**
     * 展开指定节点。
     * @method
     * @param   {Object}    nodeData    指定节点数据对象
     * @returns {Promise}
     */
    expandNode(nodeData)
    {
      return new Promise((resolve, reject) =>
      {
        this.$nextTick(() =>
        {
          this.defExpands = [nodeData[this.nodeKey]]
          this.$refs.tree.$emit('node-expand', nodeData)
          resolve({})
        })
      })
    },
    /**
     * 根据路径寻找节点
     * @method
     * @param   {String}    path    目录全路径
     * @returns {Object}    找到的节点对象
     */
    findNode(path)
    {
      let node = null
      let findNode = list =>
      {
        if (list.find(item => item.path === path))
          node = list.find(item => item.path === path)
        else
          list.forEach(item => findNode(item.children || []))
      }
      findNode(this.data)
      return node
    },
    /**
     * 根据当前选中的节点对象，获取右键菜单列表。
     * @method
     * @param   {Node}            node    节点对象(node.data是节点源数据对象)
     * @returns {Array<Object>}   右键菜单列表数组
     */
    getMenu(node)
    {
      let menu =
      [
        {grp: 'importShp', name: '导入文件', callback: _ => this.$emit('upload')},
        {grp: 'onAddFolder', name: '新建文件夹', callback: _ => this.$emit('addFolder')}
      ]
      if (node.level !== 1)
        menu.push({grp: 'onDelFolder', name: '删除文件夹', callback: this.onDelFolder})
      //权限状态下，根据权限过滤
      if (this.showByPerm)
        menu = menu.filter(item => this.isShowMenu(item))
      //只读状态下，过滤菜单。
      if (this.readOnly)
        menu = menu.filter(item => this.readOnlyMenu.indexOf(item.name) !== -1)
      return menu
    },
    /**
     * 根据文件夹路径构造合法的上传文件路径
     * @method
     * @param   {String}   path   当前文件夹路径
     * @returns {String}   构造好的上传文件路径
     */
    getUploadPath(path)
    {
      if (path.indexOf('uploadfile/') === -1)
        return path
      return path.substring(path.indexOf('uploadfile/') + 11)
    },
    /**
     * 节点点击响应事件
     * @method
     * @param   {Object}    data    传递给 data 属性的数组中该节点所对应的对象
     * @param   {Object}    node    节点对应的 Node
     */
    handleNodeClick(data, node)
    {
      // this._contextmenu.hide()
      this.selNode = data
      this.$emit('click', data, node)
    },
    /**
     * 确定按钮的点击相应函数
     * @method
     * @param    {Boolean}   setDef    是否默认点击第一个节点
     */
    init(setDef = true)
    {
      this.initFileClass()
      this.makeDefFolders().then(_ =>
      {
        this.queryDirs(this.rootDir).then(ret =>
        {
          this.data = this.makeDirsData(ret[0])
          if (!setDef)
            return
          this.$emit('click', this.data[0])
          this.expandNode(this.data[0])
        }).catch(err =>
        {
          console.log(err)
          this.data = []
          this.$message({message: '暂无对应文件目录！', type: 'warning'})
        })
      })
    },
    /**
     * 实例化文件管理类
     * @method
     */
    initFileClass()
    {
      this.File = new File()
    },
    /**
     * 当用户进行操作时会被触发，中断用户操作，提示用户进行输入的对话框。
     * @method
     * @param   {String}  title     提示语
     * @param   {String}  [defVal]  默认值
     * @returns {Promise}
     */
    inputConfirm(title, defVal = '')
    {
      return new Promise((resolve, reject) =>
      {
        this.$prompt(title, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: defVal
        }).then(({ value }) =>
        {
          resolve(value || defVal)
        }).catch(() =>
        {
          this.$message({message: '取消输入', type: 'info'})
        })
      })
    },
    /**
     * 右键菜单权限过滤 - 根据权限对传入的右键菜单项进行判定是否显示。
     * @method
     * @param   {Object}    menuItem   右键菜单项
     * @returns {Boolean}   是否可显示
     */
    isShowMenu(menuItem)
    {
      return true
    },
    /**
     * 构造根目录下默认的子目录集合。
     * @method
     * @returns   {Promise}
     */
    makeDefFolders()
    {
      return new Promise((resolve, reject) =>
      {
        if (this.defFolders.length === 0)
          return resolve([])
        let proms = []
        //1、递归添加所有目录Promise
        let addFolder = (dir, folder) =>
        {
          if (cx.base.isObj(folder))
          {
            proms.push(this.queryDirs(`${dir}/${folder.name}`))
            if (folder.children && cx.base.isArr(folder.children))
              folder.children.forEach(item => addFolder(`${dir}/${folder.name}`, item))
          }
          else
            proms.push(this.queryDirs(`${dir}/${folder}`))
        }
        this.defFolders.forEach(item => addFolder(this.rootDir, item))
        //2、执行全部请求创建目录
        Promise.all(proms).then(resolve).catch(reject)
      })
    },
    /**
     * 根据获取到文件夹内所有文件和子文件夹的目录数据，构造符合条件的树形数据
     * @method
     * @param   {Object}    rootDir    当前图集文件夹下的所有文件和子文件夹
     * @returns {Object}    构造好的树形目录数据
     */
    makeDirsData(rootDir)
    {
      let makeDir = (dir, parent) =>
      {
        cx.base.extend(dir, {path: dir.path || `${parent.path}${dir.text}`})
        if (dir.children)
        {
          dir.children = dir.children.filter(item => item.children).filter(this.filterTreeFunc)
          dir.children.forEach(item => makeDir(item, dir))
        }
      }
      let dirs = rootDir.path.split('/').filter(item => item)
      rootDir.text = dirs[dirs.length - 1]
      makeDir(rootDir)
      return [rootDir]
    },
    /**
     * 节点右键时的响应函数
     * @method
     * @param   {Event}   event   事件对象
     * @param   {Object}  data    传递给 data 属性的数组中该节点所对应的对象
     * @param   {Node}    node    节点对应的 Node
     * @param   {Node}    refNode 节点组件本身
     */
    nodeContext(event, data, node, refNode)
    {
      event.preventDefault()
    },
    /**
     * 新建文件夹
     * @method
     */
    onAddFolder(callback)
    {
      this.inputConfirm('文件夹名称输入').then(folderName =>
      {
        this.selNode = this.selNode || this.$refs.tree.getNode(this.data[0]).data
        this.File.createDir(`${this.selNode.path}${folderName}/`).then(ret =>
        {
          this.$refs.tree.append(cx.base.extend(ret, {text: folderName, isFile: false, isRoot: false, path: `${this.selNode.path}${folderName}/`, children: []}), this.selNode)
          if (this.selNode)
            this.expandNode(this.selNode)
          cx.base.call(callback)
        }).catch(this.onError)
      })
    },
    /**
     * 删除文件
     * @method
     */
    onDelFile()
    {
      this.$confirm(`是否确定删除该文件【${this.selNode.text}】?`).then(ret =>
      {
        //1、删除文件
        this.delFile(this.selNode.path).then(ret => this.$refs.tree.remove(this.selNode)).catch(this.onError)
      })
    },
    /**
     * 删除文件夹
     * @method
     */
    onDelFolder(node = this.selNode, callback)
    {
      let msg = `是否确定删除文件夹【${node.text}】及其下面的所有文件?`
      if (node.children.length !== 0)
        msg = `该文件夹【${node.text}】不为空,是否确定删除该文件夹及其下面的所有文件?`
      this.$confirm(msg).then(ret =>
      {
        //1、删除文件夹
        this.File.delDir(node.path).then(ret =>
        {
          this.$refs.tree.remove(node)
          cx.base.call(callback)
        }).catch(this.onError)
      })
    },
    /**
     * 异常处理函数
     * @method
     * @param   {Object}    err   异常信息对象
     */
    onError(err)
    {
      console.error(err)
    },
    queryDirs(dir)
    {
      return this.File.queryDirs(dir)
    },
    setCurNode()
    {
      this.selNode = this.findNode(this.curPath) || this.selNode
    },
    /**
     * 将目录树的根节点进行排序
     * @param   {Array<Object>}     data    一级树节点集合
     * @returns {Array<Object>}     过滤好的一级节点数据集合
     */
    sortRootDir(data)
    {
      return data.sort((a, b) => a.children ? -1 : 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/com/fileManage/FileTree.vue